import { set } from 'date-fns';
import { useEffect, useState, createContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Home, Sports, Sport, About, NotFound, EventDetails } from '../views';
import { MainLayout } from './Layout';
import axios from 'axios';
import { useRef } from 'react';
import { PendingBetsProvider } from '../context/PendingBetsContext';
import 'react-toastify/dist/ReactToastify.css';
import { useAppStore } from '../store/AppStore';


const APIContext = createContext();
/**
 * List of routes available only for anonymous users
 * Also renders the "Main Layout" composition
 * @component MainRoutes
 */
var globalIntervalRef;
function shutoff(){
  console.log("shutoff ran");
  clearInterval(globalIntervalRef.current);
}

function updateOB(ob0, ob1, side, odds, stake){
  //based on odds that were just bet, update api_data
  //if user's bet is at higher odds than is avaiable on user's side,
  var betOB = side == 0 ? ob0 : ob1; //changing betOB changes ob0 or ob1 because it is a reference
  //console.log(odds, betOB.highestOdds);
  while(odds <= betOB.highestOdds && stake > 0){  
    if(stake >= betOB.stakeAtHighestOdds){
      // if user's bet matches or is lower than some odds in the orderbook, 
      //clear everything above and decrease stakes as necessary
      //advance everything below up, just have blank to fill in bottom, it will be reloaded in 15 sec
      stake -= betOB.stakeAtHighestOdds;
      betOB.stakeAtHighestOdds = betOB.stakeAt2ndHighestOdds;
      betOB.highestOdds = betOB.secondHighestOdds;

      betOB.stakeAt2ndHighestOdds = betOB.stakeAt3rdHighestOdds;
      betOB.secondHighestOdds = betOB.thirdHighestOdds;

      betOB.stakeAt3rdHighestOdds = 0;
      betOB.thirdHighestOdds = 0;
    }
    else{
      //only partially matched
      betOB.stakeAtHighestOdds -= stake;
      stake = 0;
      console.log("else condition ran, betOB.stakeAtHighestOdds", betOB.stakeAtHighestOdds, "stake", stake);
    }
  }
  //everything was matched/aggregated, no liquidity needs to show up on the other side
  if(stake <= 0){
    return;
    //return [ob0, ob1];
  }
  // find inverse of the odds to put on other side.
  var invOdds = divMinus1(odds);
  var liquidity = invStake(stake, odds);
  var otherOB = side == 0 ? ob1 : ob0; //when otherOB changes, attrs of ob1 or ob0 will change
  // If higher than highestOdds, secondHighestOdds, or thirdHighestOdds, set appropriate field and shift appropriately 
  if(invOdds > otherOB.highestOdds){
    otherOB.thirdHighestOdds = otherOB.secondHighestOdds;
    otherOB.stakeAt3rdHighestOdds = otherOB.stakeAt2ndHighestOdds;
    otherOB.secondHighestOdds = otherOB.highestOdds;
    otherOB.stakeAt2ndHighestOdds = otherOB.stakeAtHighestOdds;
    otherOB.highestOdds = invOdds;
    otherOB.stakeAtHighestOdds = liquidity;
  //shift
  }
  else if(invOdds == otherOB.highestOdds){
    otherOB.stakeAtHighestOdds += liquidity;
  }
  else if(invOdds > otherOB.secondHighestOdds){
    otherOB.thirdHighestOdds = otherOB.secondHighestOdds;
    otherOB.stakeAt3rdHighestOdds = otherOB.stakeAt2ndHighestOdds;
    otherOB.secondHighestOdds = invOdds;
    otherOB.stakeAt2ndHighestOdds = liquidity;
  }
  else if(invOdds == otherOB.secondHighestOdds){
    otherOB.stakeAt2ndHighestOdds += liquidity;
  }
  else if(invOdds > otherOB.thirdHighestOdds){
    otherOB.thirdHighestOdds = invOdds;
    otherOB.stakeAt3rdHighestOdds = liquidity;
  }
  else if(invOdds == otherOB.thirdHighestOdds){
    otherOB.stakeAt3rdHighestOdds += liquidity;
  }
  //return [ob0, ob1];
  //dont return anything because edits by reference will update api_data correctly
}

function divMinus1(odds){
  return Math.round(100 * odds / (odds - 1)) / 100;
}

function invStake(stake, odds){
  return Math.round(100 * stake * (odds - 1)) / 100;
}

function toggleOB(ob, needSwitch){
  /* toggle already takes care of this
  if(needSwitch){ //if this is true, we are in traditional mode
    ob.stakeAtHighestOdds = invStake(ob.stakeAtHighestOdds, ob.highestOdds);
    ob.stakeAt2ndHighestOdds = invStake(ob.stakeAt2ndHighestOdds, ob.secondHighestOdds);
    ob.stakeAt3rdHighestOdds = invStake(ob.stakeAt3rdHighestOdds, ob.thirdHighestOdds);
  }
  */
  ob.highestOdds = divMinus1(ob.highestOdds);
  ob.secondHighestOdds = divMinus1(ob.secondHighestOdds);
  ob.thirdHighestOdds = divMinus1(ob.thirdHighestOdds);
  //console.log(ob.stakeAtHighestOdds, "at", ob.highestOdds);
  //dont return anything because everything is done by references for simplicity
}

const MainRoutes = () => {
  const [api_data, setAPIData] = useState(null);
  const [state, dispatch] = useAppStore();
  const intervalRef = useRef();
  globalIntervalRef = intervalRef;

  useEffect(() => {
    if(state.urlChangeSignal == "init"){
      return; //want to avoid default calling the main API on every load, especially on /sport/xxx or /view/eventxxx 
    }
    clearInterval(globalIntervalRef);
    //console.log("state.urlChangeSignal has changed so calling new api");
    getAPIData(process.env.REACT_APP_API_URL + state.urlAddOn)
    var interval = setInterval(() => {
        if (!document.hidden) getAPIData(process.env.REACT_APP_API_URL + state.urlAddOn);
    } , process.env.REACT_APP_API_CALL_INTERVAL);
    intervalRef.current = interval;
    return () => clearInterval(interval);
  }, [state.urlChangeSignal]);

  //this gets called after a user places a bet, so that the trading page updates instantly
  useEffect(() => {
    if(state.justbet == "init"){
      return;
    }
  }, [state.justbet])

  const getAPIData = (url) => {
    axios.get(url)
      .then((response) => {
        if (response?.status === 200) {
          const { data } = response;
          setAPIData(data);
        }
      })
      .catch((err) => {
        console.error(err);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      });
  };

  return (
    <PendingBetsProvider>
      <MainLayout>
        <APIContext.Provider value={api_data}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sports/*" element={<Sports />} />
            <Route path="/view/:sportsSlug/:eventName" element={<EventDetails />} />
            <Route path="/404" element={<NotFound />} /> {/* In case when we want to Navigate to 404*/}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </APIContext.Provider>
      </MainLayout>
    </PendingBetsProvider>
  );
};

export { MainRoutes as default, APIContext, shutoff};
